// extracted by mini-css-extract-plugin
module.exports = {"input_group":"Form_input_group__ShipD","input_text":"Form_input_text__8qG1u","button":"Form_button__Jsx6p","button_custom":"Form_button_custom__DNuz8"};